import instance from "./api";

export default {
  getTags: async (params) => {
    return instance.get("/posts/tags", { params });
  },
};
